<div [class.fullcontainer]='!this.isPopup'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Order was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Order - {{ this.order.account.name }}/{{ this.order.site.name }}</h1>
    <app-audit-line [data]='this.order'></app-audit-line>
    <form method='post' (ngSubmit)='this.onSubmit()'>
      <app-order-form [isTransport]="this.isTransport" [priceListType]="'pricelist'" [materialUplifts]='this.materialUplifts' [account]='this.order.account' [site]='this.order.site' [order]='this.order' [orderLines]='this.orderLines' [fromTime]='this.fromTime' [toTime]='this.toTime'></app-order-form>
      @if (this.canEdit) {
        <button type="submit" class="btn btn-success">Save</button>
        }&nbsp;
        <button type="button" class="btn btn-danger" (click)='cancel()'>Cancel</button>
      </form>
    </div>
  </div>
